import { render, staticRenderFns } from "./CotizadorCard.vue?vue&type=template&id=6edf6e39&scoped=true"
import script from "./CotizadorCard.vue?vue&type=script&lang=js"
export * from "./CotizadorCard.vue?vue&type=script&lang=js"
import style0 from "./CotizadorCard.vue?vue&type=style&index=0&id=6edf6e39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edf6e39",
  null
  
)

export default component.exports